import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
const favIcon = "/logo/seatrcred.svg"; // Pastikan path ini benar sesuai struktur folder Anda
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { motion, AnimatePresence } from "framer-motion";

export const Navbar = () => {
  const [user, setUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");
  const auth = getAuth();
  const menuRef = useRef(null);

  // URL untuk file Excel Google Sheets
  const formUrl = "https://docs.google.com/spreadsheets/d/1vzPSgy9wjqW9cPkaYqtX0NY54MDKP3zf/edit?usp=sharing&ouid=113930544406847393276&rtpof=true&sd=true";

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, [auth]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleHamburgerClick = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = (action) => {
    if (action === "navigate") {
      setMenuOpen(false);
    }
  };

  return (
    <nav className="w-full sticky-navbar mt-7 py-3 bg-white shadow-lg text-gray-800">
      <div
        className="container mx-auto px-4 flex items-center justify-between"
        ref={menuRef}
      >
        {/* Logo & Desktop text */}
        <div className="flex-1 md:flex md:items-center">
          <Link
            to="/"
            className="flex items-center space-x-4 text-2xl font-bold mx-auto md:mx-0"
            onClick={() => setActiveMenu("home")}
          >
            <img src={favIcon} alt="Logo" className="h-10 w-auto" />
            <span className="hidden md:block text-2xl font-black text-red-900">
              SEATRC
            </span>
          </Link>
        </div>

        {/* Mobile centered text */}
        <span className="block md:hidden absolute left-1/2 transform -translate-x-1/2 text-base font-semibold whitespace-nowrap">
          SEATRC
        </span>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center space-x-8 md:space-x-4 text-base uppercase font-medium px-8 md:px-04">
          <Link
            to="/"
            className={`hover:text-red-900 ${
              activeMenu === "home" ? "border-b-2 border-red-900 text-red-900" : ""
            }`}
            onClick={() => setActiveMenu("home")}
          >
            HOME
          </Link>

         {/*  <Link
            to="/information"
            className={`hover:text-red-900 ${
              activeMenu === "information" ? "border-b-2 border-red-900 text-red-900" : ""
            }`}
            onClick={() => setActiveMenu("information")}
          >
            INFORMATION
          </Link> */}

          <Link
            to="/schedule"
            className={`hover:text-red-900 ${
              activeMenu === "schedule" ? "border-b-2 border-red-900 text-red-900" : ""
            }`}
            onClick={() => setActiveMenu("schedule")}
          >
            SCHEDULE
          </Link>

          {/* --- MENU BARU: FORM --- */}
          {/* Menggunakan tag <a> karena link eksternal */}
          <a
            href={formUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-red-900 cursor-pointer"
          >
            ENTRY FORM
          </a>

          <Link
            to="/kontak"
            className={`hover:text-red-900 ${
              activeMenu === "contact" ? "border-b-2 border-red-900 text-red-900" : ""
            }`}
            onClick={() => setActiveMenu("contact")}
          >
            CONTACT
          </Link>
        </div>

        {/* Desktop: user links including MY REGISTRATION and PROFILE */}
        {/* Desktop: user links removed as per request */}
        {/* <div className="hidden md:flex items-center space-x-4"> ... </div> */}

        {/* Mobile hamburger */}
        <button
          className="md:hidden focus:outline-none"
          onClick={handleHamburgerClick}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16m-7 6h7"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile dropdown */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full left-0 w-full bg-white shadow-lg md:hidden min-h-screen"
          >
            <div className="flex flex-col text-center w-full px-4 uppercase font-medium divide-y divide-slate-200 max-w-lg mx-auto">
              <div className="flex flex-col py-4 space-y-2">
                <Link
                  to="/"
                  className="py-2 hover:text-red-900"
                  onClick={() => {
                    setActiveMenu("home");
                    handleMenuItemClick("navigate");
                  }}
                >
                  HOME
                </Link>

                {/* <Link
                  to="/information"
                  className="py-2 hover:text-red-900"
                  onClick={() => {
                    setActiveMenu("information");
                    handleMenuItemClick("navigate");
                  }}
                >
                  INFORMATION
                </Link> */}

                <Link
                  to="/schedule"
                  className="py-2 hover:text-red-900"
                  onClick={() => {
                    setActiveMenu("schedule");
                    handleMenuItemClick("navigate");
                  }}
                >
                  SCHEDULE
                </Link>

                {/* --- MENU BARU: FORM (Mobile) --- */}
                <a
                  href={formUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="py-2 hover:text-red-900"
                  onClick={() => {
                     setMenuOpen(false); // Menutup menu saat diklik
                  }}
                >
                  ENTRY FORM
                </a>

                <Link
                  to="/kontak"
                  className="py-2 hover:text-red-900"
                  onClick={() => {
                    setActiveMenu("contact");
                    handleMenuItemClick("navigate");
                  }}
                >
                  CONTACT
                </Link>
              </div>

              {/* Profile Related Links for mobile */}
              {/* Profile/Login links removed as per request */}
              {/* {user ? ( ... ) : ( ... )} */}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;